import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-bold text-primary-500 font-heading">
              棒棒TV
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              海量高清影视内容，电视剧全集、电影大全、热门综艺、精品动漫，免费在线观看，高清不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                首页
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                联系我们
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <p>邮箱：contact@bangbangtv.com</p>
              <p>电话：400-888-8888</p>
              <p>地址：北京市朝阳区望京科技园区</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 棒棒TV - 版权所有 | 好剧好电影，尽在棒棒TV
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}